export const height100PCT = () => ({
  height: "100%",
});
